import react from "react";
import Request from "../../../api/Requests";

const getAccountInfo = (params) => {
    return Request('billing/info-form-account', 'GET', params, true);
}

const saveAccountInfo = (params) => {
    return Request('billing/save-account', 'POST', params, true);
}

const getSubscritionInfo = (params) => {
    return Request('billing/info-form-subscrition', 'POST', params, true);
}

const setSubscriptionPlan = (params) => {
    return Request('billing/create-subscrition-checkout', 'POST', params, true);
}

const getCheckoutInfo = (params) => {
    return Request('billing/info-check-out', 'GET', params, true);
}


const saveCheckout = (params) => {
    return Request('billing/save-check-out', 'POST', params, true);
}

const getTransactionsList = (params) => {
    return Request('billing/info-transactions-list', 'GET', params, true);
}

const getSubscritionFinishInfo = (params) => {
    return Request('billing/info-checkout-finish-info', 'GET', params, true);
}

const getInvoiceList = (params) => {
    return Request('billing/info-invoice-list', 'GET', params, true);
}



export default {
    getAccountInfo,
    saveAccountInfo,
    getSubscritionInfo,
    setSubscriptionPlan,
    getCheckoutInfo,
    saveCheckout,
    getTransactionsList,
    getSubscritionFinishInfo,
    getInvoiceList
}